import VState from 'signal/v-state'

export default new VState({})
